<template>
  <div class="about">
    <!-- banner -->
    <div style="width: 100%; position: relative">
      <img
        style="width: 100%; height: 100%"
        src="@/images/joinus/about.png"
        alt=""
      />
      <div
        style="
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        "
      >
        <span style="display: flex; align-items: center">
          <!-- <img
            style="
              font-size: 0;
              width: 0.36rem;
              height: 0.36rem;
              margin-right: 12px;
            "
            src="@/images/common/iconblue.png"
            alt=""
          /> -->
          <span class="txt">关于我们</span>
        </span>
      </div>
    </div>
    <div class="warper">
      <!-- 关于我们 -->
      <!-- <div class="flex-items" style="margin: 50px 0">
        <img
          style="width: 40px; height: 40px; font-size: 0"
          src="@/images/icon/KJY_yuan1.png"
          alt=""
        />
       >
      </div> -->
      <!-- Main -->
      <div class="main">
        <div class="left">
          <div class="title">关于我们</div>
          <div
            v-for="(item, index) in list"
            :key="index"
            v-html="item.text"
            style="
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #000028;
            "
          >
            {{ item.text }}
          </div>
        </div>
        <div class="right">
          <img
            style="width: 100%; height: 100%"
            src="@/images/common/about1.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <!-- 中间banner -->
    <div style="position: relative; width: 100%; height: 700px">
      <div style="width: 100%; height: 300px; position: relative">
        <img
          style="width: 100%; height: 100%"
          src="@/images/common/team.png"
          alt=""
        />
        <div
          style="
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          "
        >
          <span style="display: flex; align-items: center">
            <!-- <img
              style="
                font-size: 0;
                width: 0.36rem;
                height: 0.36rem;
                margin-right: 12px;
              "
              src="@/images/common/iconblue.png"
              alt=""
            /> -->
            <span class="txt" style="font-size: 32px">我们的技术团队</span>
          </span>
        </div>
      </div>
      <div class="kjy-video">
        <video-player
          class="video-player vjs-custom-skin"
          ref="videoPlayer"
          :playsinline="true"
          :options="playerOptions"
        ></video-player>
      </div>
    </div>
    <!-- gif动图 -->
    <div class="container">
      <div class="warper">
        <ul class="open">
          <li class="ams-aboutUs-airline-port-item" style="top: 32%; left: 44%">
            <a href="javascript:;"
              >近洋航线<i class="iconfont icon-iright"></i
            ></a>
          </li>
          <li class="ams-aboutUs-airline-port-item" style="top: 28%; left: 10%">
            <a href="javascript:;"
              >欧洲航线<i class="iconfont icon-iright"></i
            ></a>
          </li>
          <li class="ams-aboutUs-airline-port-item" style="top: 43%; left: 6%">
            <a href="javascript:;"
              >地中海航线<i class="iconfont icon-iright"></i
            ></a>
          </li>

          <li class="ams-aboutUs-airline-port-item" style="top: 52%; left: 6%">
            <a href="javascript:;"
              >非洲航线<i class="iconfont icon-iright"></i
            ></a>
          </li>
          <li class="ams-aboutUs-airline-port-item" style="top: 50%; left: 14%">
            <a href="javascript:;"
              >红海航线<i class="iconfont icon-iright"></i
            ></a>
          </li>
          <li class="ams-aboutUs-airline-port-item" style="top: 45%; left: 16%">
            <a href="javascript:;"
              >中东航线<i class="iconfont icon-iright"></i
            ></a>
          </li>
          <li class="ams-aboutUs-airline-port-item" style="top: 49%; left: 26%">
            <a href="javascript:;"
              >印巴航线<i class="iconfont icon-iright"></i
            ></a>
          </li>
          <li
            class="ams-aboutUs-airline-port-item noHover"
            style="top: 44%; left: 72%"
          >
            <p>美国</p>
            <i class="el-icon-location" style="top: -10px; left: 37px"></i>
          </li>
          <li
            class="ams-aboutUs-airline-port-item noHover"
            style="top: 46%; left: 23%"
          >
            <p>迪拜</p>
            <i class="el-icon-location" style="top: -10px; right: 36px"></i>
          </li>
          <li
            class="ams-aboutUs-airline-port-item noHover"
            style="top: 48%; left: 35%"
          >
            <p>香港</p>
            <i class="el-icon-location" style="top: -12px; left: 36px"></i>
          </li>
          <li class="ams-aboutUs-airline-port-item" style="top: 58%; left: 37%">
            <a href="javascript:;"
              >东南亚航线<i class="iconfont icon-iright"></i
            ></a>
          </li>
          <li class="ams-aboutUs-airline-port-item" style="top: 66%; left: 41%">
            <a href="javascript:;"
              >澳新航线<i class="iconfont icon-iright"></i
            ></a>
          </li>
          <li class="ams-aboutUs-airline-port-item" style="top: 60%; left: 80%">
            <a href="javascript:;"
              >南美航线<i class="iconfont icon-iright"></i
            ></a>
          </li>
          <li class="ams-aboutUs-airline-port-item" style="top: 29%; left: 67%">
            <a href="javascript:;"
              >美加航线<i class="iconfont icon-iright"></i
            ></a>
          </li>
        </ul>
      </div>
    </div>
    <!-- 我们的客服团队 -->
    <div class="warper">
      <!-- 关于我们 -->
      <!-- <div class="flex-items" style="margin: 80px 0 50px">
        <img
          style="width: 40px; height: 40px; font-size: 0"
          src="@/images/icon/KJY_yuan1.png"
          alt=""
        />
        <div class="title">我们的客服团队</div>
      </div> -->
      <div class="team">
        <div class="left">
          <div class="title" style="margin-bottom: 24px;">我们的客服团队</div>
          <p>满足客户需求，超越客户期待.</p>
          <p>
            从接受您的订单需求开始，我们的全员团队就已经为您的货物展开了从配柜、仓储、配送、报关、装箱、签单、到港、查询等一系列的服务。我们全心全意，使命必达。
          </p>
          <p>
            无论新老客户，跨境易都将您视为最尊贵的客人。“满足客户需求，超越客户期待”是我们的准则，跨境易致力于为您提供卓越的综合物流服务。
          </p>
        </div>
        <div class="right">
          <img class="letftop" src="@/images/common/letftop.png" alt="" />
          <img
            class="rightbonnom"
            src="@/images/common/rightbonnom.png"
            alt=""
          />
          <div class="bannerContainer" style="width: 520px">
            <el-carousel height="280px" indicator-position="outside">
              <el-carousel-item>
                <img
                  src="@/images/common/xxxlunbo.png"
                  style="height: 100%; width: 100%; vertical-align: middle"
                  alt=""
                />
              </el-carousel-item>
              <el-carousel-item>
                <img
                  src="@/images/common/xxxlunbo.png"
                  style="height: 100%; width: 100%; vertical-align: middle"
                  alt=""
                />
              </el-carousel-item>
              <el-carousel-item>
                <img
                  src="@/images/common/xxxlunbo.png"
                  style="height: 100%; width: 100%; vertical-align: middle"
                  alt=""
                />
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";

export default {
  components: {
    videoPlayer,
  },
  data() {
    return {
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {     //线上凯通宣传视频
            src: "https://minio.cargoee.com/cargoee/KT_jbkj2.mp4", // 路径
            type: "video/mp4", // 类型
          },
        ],
        // poster: "../../static/images/test.jpg", //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
      list: [
        {
          text: '<p>浙江凯通物流有限公司是一家在 <span style="color: #376bf6;">宁波口岸发展迅速的国际化综合服务型物流企业</span>，主营业务为亚马逊运输、国际海运、空运等进出口物流业务，为终端客户提供一体化的物流集成解决方案。目前公司拥有50多名物流精英人才，为国内外客户提供代理订舱、报关、报检、货物检验、监装、目的港仓储配送到门等全能性物流服务。</p>',
        },
        {
          text: "<p>一直以来，凯通始终坚持以创新和专业推动中国物流发展为使命，以客户为中心，以诚信致远为价值导向，以创新共赢为经营理念，严格执行标准化物流作业，为广大客户提供安全、快速、便捷、满意的物流服务。凯通通过不懈追求物流创新，关注客户需求追求完美服务，为客户节约成本，提供超值的物流服务。</p>",
        },
        {
          text: "<p>先进的物流服务理念，完善的物流信息系统，优秀的员工团队铸造了凯通高效科学的内部管理和客户服务体系。</p>",
        },
        {
          text: "<p>个性化服务的物流服务，是我们努力的精髓。凯通针对不同客户的物流需求，在价格时效优化的基础上，为客户设计整体物流方案，提高物流管理效率及客户体验度。作为不断追求卓越的现代物流企业，凯通以高起点、高标准的企业定位、管理水平和超常的发展速度而名动业界。</p>",
        },
        {
          text: "<p>我们公司专门为亚马逊电商客户量身打造，到欧洲各国，美加，日本，墨西哥等国家，提供FBA空派，海派， 铁路运输等多种运输服务。</p>",
        },
      ],
    };
  },
};
</script>
<style scoped>
.about {
  width: 100%;
  background: #f6f7f9;
}
.warper {
  width: 12rem;
  margin: 0 auto;
  overflow: hidden;
}
.txt {
  font-size: 40px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
}
.flex-items {
  display: flex;
  align-items: center;
}

/* .about-news{
    d
} */
/* main */
.main {
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
  margin: 70px 0;
}
.main .left {
  width: 48%;
}
.main .left .title,.team .left .title{
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #f7841e;
  margin-bottom: 45px;
}
.main .left div {
  font-size: 16px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #555658;
  line-height: 22px;
  margin-bottom: 20px;
}
.main .right {
  width: 50%;
  /* height: 340px; */
}
/* main end */
/*  gif动图*/
.container {
  /* margin-top: 54px; */
  background: #fff;
  padding: 50px 0;
  box-sizing: border-box;
}
.open {
  width: 100%;
  height: 720px;
  position: relative;
  background-size: cover !important;
  background: url("../../images/common/world.gif") center center no-repeat;
}
.ams-aboutUs-airline-port-item {
  position: absolute;
  padding: 15px 30px;
  display: inline-block;
}
.el-icon-location {
  font-size: 20px;
  display: inline-block;
  width: 21px;
  height: 30px;
  position: absolute;
}
.open a {
  font-size: 16px;
  color: #007bff;
}
a:hover {
  color: #0056b3;
}
/* gif动图 end */
/* team */
.team {
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
  margin-bottom: 100px;
  padding: 30px 0 ;
  box-sizing: border-box;
}
.team .left {
  width: 520px;
}
.team .left p {
  font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000028;
  line-height: 34px;
}
.team .right {
  padding: 20px;
  box-sizing: border-box;
  position: relative;
}
.rightbonnom {
  width: 88px;
  height: 122px;
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 9;
}
.letftop {
  width: 88px;
  height: 122px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 9;
}
</style>
<style >
.kjy-video {
  /* margin: -100px auto 0; */
  left: 50%;
  bottom: 40px;
  transform: translate(-50%, 5%);
  position: absolute;
  width: 800px;
  /* height: 450px; */
  background: #ffffff;
  padding: 22px;
  box-sizing: border-box;
  overflow: hidden;
  z-index: 9;
}
.video-player {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
/* 设置播放按钮的形状与位置 */
.video-js .vjs-big-play-button {
  left: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%);
  box-shadow: 0px 0px 50px 15px rgb(255 255 255/ 100%);
}
</style>


// WEBPACK FOOTER //
// src/components/About/index.vue